import type { GuidedListSpec } from '../../../types/guidedList'
import { SCORE_BANDS, SCORE_KNOBS } from '../../../types/guidedList'
import { FLAG_BADGES } from '../../../types/analyticsFlags'

/** Plain-language chips describing what the Audience step narrowed to. OUR words only —
 *  never a raw Catalist enum/field name. Empty for wide-net defaults: the three on-by-default
 *  hygiene flags (registeredDemOnly/registrationActiveOnly/excludeDeceased) are implicit and
 *  never surfaced here. */
export function summarizeAudience(spec: GuidedListSpec): string[] {
  const chips: string[] = []
  for (const k of SCORE_KNOBS) {
    const sel = spec[k.specKey as keyof GuidedListSpec] as string[]
    if (!sel?.length) continue
    const labels = SCORE_BANDS[k.bands].filter(b => sel.includes(b.key)).map(b => b.label)
    // ideology bands read standalone ("Progressive"); the L/M/H scores get their dimension name
    chips.push(k.bands === 'ideology' ? labels.join(' / ') : `${labels.join(' / ')} ${k.label.replace(/^General /, '')}`)
  }
  const demo: [keyof GuidedListSpec, (v: string) => string][] = [
    ['races', v => v.charAt(0).toUpperCase() + v.slice(1)],
    ['genders', v => v], ['generations', v => v], ['ageBins', v => v],
    ['urbanities', v => v], ['incomeBins', v => v],
  ]
  for (const [key, fmt] of demo) {
    const sel = spec[key] as string[]
    if (sel?.length) chips.push(sel.map(fmt).join(', '))
  }
  for (const fk of spec.smartFlags) chips.push(FLAG_BADGES[fk]?.label ?? fk)
  return chips
}
